module.exports = __webpack_public_path__ + "static/media/duplicateProfile.f19049af.svg";